/// <amd-module name="Dashboards/DashboardView/src/components/headers/DashboardOptions" />
import * as React from "react";
import { connect } from "react-redux";

import { DashboardActions } from "../../redux/actions/Actions";
import { DashboardViewAwareState } from "../../model/DashboardViewState";

import * as Resources from "Dashboards/DashboardView/Resources";

import { ITfsPageDataAwareState } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataContracts";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { MoreButton } from "VSSUI/Menu";
import { IconSize } from "VSSUI/Icon";


interface ConnectedDashboardOptionsMappedProps {
}

interface IDashboardOptionsProps extends ConnectedDashboardOptionsMappedProps {}

export class DashboardOptions extends VssComponent<IDashboardOptionsProps & typeof Actions> {

    public constructor(props: any, context?: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element | null {
        return (
            <MoreButton
                subtle
                iconProps={{iconName: "More"}}
                contextualMenuProps={{
                    menuProps: {
                        id: "dashboard-more-actions-menu",
                        ariaLabel: Resources.Header_MoreActionsMenuAriaLabel,
                        items: [
                            {
                                id: "copy-dashboard-button",
                                text: Resources.Header_CopyDashboardText,
                                onActivate: this.onCopyDashBoardActivate,
                                iconProps: {iconName: "Add", size: IconSize.small}
                            }
                        ]
                    }
                }}
            />
        );
    }

    private onCopyDashBoardActivate = (): any => this.props.onCopyDashBoardClick();
}

function mapStateToProps(state: DashboardViewAwareState & ITfsPageDataAwareState): ConnectedDashboardOptionsMappedProps {
    return {
    };
}

const Actions = {
    onCopyDashBoardClick: DashboardActions.activateCopyDashboardPanel
};

export const ConnectedDashboardOptions = connect(mapStateToProps, Actions)(DashboardOptions);